import moment from "moment"
import { getEquipmentDisplay, ScheduleDateFormats } from "../types"
import { getTz } from "../../../utils/getTimezone"

export function getInviteMessage(hostName: string, title: string, link: string, startTime?: number | null, equipments?: string[] | null): string {
  const datePart = startTime ? `\nWhen: ${moment(startTime).format(ScheduleDateFormats.longDate)} ${getTz()}` : ""
  return `${hostName} has invited you to join a class together\n\n${title}${datePart}\nEquipment: ${getEquipmentDisplay(equipments ?? [])}\n\nPrivate link\n${link}`
}